import type { PhotoPose, ProgressPhotoOutput } from '@st/contract';
import type { Locale } from '@st/i18n';
import { formatDate } from './format';

/**
 * Poza je enum na API-ju (`progress_photos.pose`), ne slobodan tekst. Ključevi
 * su ovdje da ih i galerija i obrazac za prijenos mapiraju na isti način —
 * isti razlog zbog kojeg `MEAL_SLOT_KEY` živi u `lib/nutrition.ts`.
 */
export const PHOTO_POSE_KEY: Record<PhotoPose, string> = {
  front: 'progress.poseFront',
  side: 'progress.poseSide',
  back: 'progress.poseBack',
  other: 'progress.poseOther',
};

/**
 * Opis ispod fotografije. API vraća `takenOn` i `note`; `caption` koji je portal
 * prije čitao nikad nije ni postojao. Datum ide uvijek — bez njega usporedba
 * „prije / sada" ne govori koliko je vremena prošlo.
 */
export function photoCaption(
  photo: ProgressPhotoOutput,
  t: (key: string) => string,
  locale: Locale,
): string {
  const date = formatDate(`${photo.takenOn}T00:00:00.000Z`, locale);
  return photo.note ? `${date} · ${photo.note}` : `${date} · ${t(PHOTO_POSE_KEY[photo.pose])}`;
}

/**
 * Najstarija i najnovija fotografija za usporedbu.
 *
 * Ruta vraća `ORDER BY taken_on DESC`, a mock je dugo vraćao uzlazno — ekran je
 * zato u demou izgledao ispravno, a nad pravim API-jem bi „Prije" pokazivalo
 * najnoviju sliku. Redoslijed se ovdje određuje iz samog datuma, pa poredak
 * odgovora više nije bitan.
 */
export function comparePair(
  photos: readonly ProgressPhotoOutput[],
): { oldest: ProgressPhotoOutput; newest: ProgressPhotoOutput } | null {
  if (photos.length < 2) return null;
  const sorted = [...photos].sort((a, b) => a.takenOn.localeCompare(b.takenOn));
  return { oldest: sorted[0]!, newest: sorted[sorted.length - 1]! };
}
